export function isInIframe(): boolean {
  try {
    return window.self !== window.top
  } catch {
    // Si l'accès à window.top est bloqué (cross-origin), on est dans une iframe
    return true
  }
}
